import { Avatar, Box, Grid, Paper, Switch, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import { toast } from 'react-toastify';

import palette from '../../theme/palette';
import Key from '../../clientVariables.json';
import { useResponsiveStyles } from '../../utils/responsiveStyles';
import OverView from './details/OverView';
import CompanyDetails from './details/CompanyDetails';
import Users from './details/Users';
import CustomerPackageInfo from '../CustomerPackageInfo';
import Mail from '../Mail';
import CustomerNotes from '../CustomerNotes';
import Activity from '../Activity';
import Package from './details/Package';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const DetailsView = ({ selectedCustomer }) => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const [customerDetailsData, setCustomerDetailsData] = useState(null);
  const [value, setValue] = React.useState(0);
  const styles = useResponsiveStyles();
  const [active, setActive] = useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (selectedCustomer) {
      getCustomerDetails(selectedCustomer?.userid);
      console.log('selectedCustomer', selectedCustomer);
      setActive(parseInt(selectedCustomer?.user_status, 10) === 1);
    }
  }, [selectedCustomer]);


  const getCustomerDetails = async (id) => {
    try {
      const response = await axios.post(`${Key.domain}/customer/get_customerdetails`, {
        customer_id: id,
      });
      if (response.status === 200) {
        setCustomerDetailsData(response.data.data);
        console.log(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const customerDeactivateHandler = (event) => {
    setActive(event.target.checked);
    cutomerDeactivate();

  }

  const cutomerDeactivate = async() => {
    try {
        // const response = await axios.post(`${Key.domain}/customer/deactivate_jnp_user`, {
        //     email: customerDetailsData?.userDetails?.username
        // });
        const response = await axios.post(`${Key.domain}/customer/active_inactive`, {
          userid: customerDetailsData?.userDetails?.username,
          admin_id: currentUser?.id,
          status: 0,
          //  parseInt(customerDetailsData?.userDetails?.user_status, 10) === 1 ? 0 : 1,
          session_token: currentUser?.session_token,
      });
        if(response.status === 200){
            toast.success(`Successfully Customer(${customerDetailsData?.userDetails?.username}) Deactivated`, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
        }
    } catch (error) {
        console.error(error);
        setActive(true);
        toast.error(`Failed to Customer(${customerDetailsData?.userDetails?.username}) Deactivated try again!`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
    }
  }

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[600],
  };

  return (
    <Grid container spacing={0} sx={{ border: `1px solid ${palette.grey[300]}` }}>
      <Grid item xs={12}>
        <Box sx={{ p: '10px', display: 'flex' }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography paragraph variant="h4" sx={{ m: 0, color: palette.grey[800], textTransform: 'capitalize' }}>
              {customerDetailsData?.userDetails?.full_name}
            </Typography>
            <Box sx={{ display: 'flex', gap: '6px' }}>
              <Avatar />
              <Box>
                <Typography paragraph sx={{ ...text1Styles }}>
                  {customerDetailsData?.userDetails?.role}
                </Typography>
                <Typography paragraph sx={{ ...text1Styles }}>
                  {customerDetailsData?.companyDetails?.name
                    ? customerDetailsData?.companyDetails?.name
                    : 'N/A'}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <FormControlLabel control={<Android12Switch checked={active} onChange={customerDeactivateHandler} />} label="Active" />
          </Box>
        </Box>
        <Box sx={{ width: '100%' }}>
          <Box
            sx={{
              borderTop: `1px solid ${palette.grey[300]}`,
              borderBottom: `1px solid ${palette.grey[300]}`,
              boxShadow: 'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px',
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons="auto"            
              sx={{
                minHeight: '42px',
                '& .MuiTab-root': {
                  fontSize: styles.fontSize12,
                  minHeight: '42px', // Ensure individual tabs also decrease in height
                  padding: '6px 12px', // Adjust padding
                  minWidth: '60px', // Decrease tab width
                  textTransform: 'uppercase', 
                  fontWeight: 500, 
                },
                '& .Mui-selected': {
                  color: '#1976d2 !important',
                  // backgroundColor: '#e3f2fd',
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#1976d2',
                },
              }}
            >
              <Tab label="Overview" {...a11yProps(0)}  />
              <Tab label="Company info" {...a11yProps(1)} />
              <Tab label="Users" {...a11yProps(2)} />
              <Tab label="Package info" {...a11yProps(3)} />
              <Tab label="Mail conversation" {...a11yProps(4)} />
              <Tab label="Queries" {...a11yProps(5)} />
              <Tab label="Activity" {...a11yProps(6)} />
              <Tab label="Actions" {...a11yProps(7)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <OverView customerDetailsData={customerDetailsData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <CompanyDetails customerDetailsData={customerDetailsData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Users customerDetailsData={customerDetailsData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Package customerDetailsData={customerDetailsData} />
            {/* <CustomerPackageInfo 
            customerId={customerDetailsData?.userDetails?.id}
            companyDetails={customerDetailsData?.companyDetails}
            packageDetails={customerDetailsData?.packageDetails}  /> */}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
          <Mail />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={5}>
          <CustomerNotes customerId={customerDetailsData?.userDetails?.id} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={6}>
            <Activity customerId={customerDetailsData?.userDetails?.id} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={7}>
            Actions
          </CustomTabPanel>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DetailsView;

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

// // /* eslint-disable */

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Avatar, Box, Button, ButtonGroup, Divider, Grid, List, ListItemButton, Typography } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { useResponsiveStyles } from '../../utils/responsiveStyles';

// import palette from '../../theme/palette';
// import Key from '../../clientVariables.json';

// const DetailsView = ({ customerDetailsId }) => {
//   const currentUser = useSelector((state) => state.UserReducer.user);
//   const [customerData, setCustomerData] = useState([]);
//   const [customerDetailsData, setCustomerDetailsData] = useState(null);
//   const styles = useResponsiveStyles();
//   const [activeButton, setActiveButton] = React.useState('All');

//   const handleButtonClick = (buttonName) => {
//     setActiveButton(buttonName);
//   };

//   useEffect(() => {
//     getCustomers();
//     if (customerDetailsId) {
//       getCustomerDetails(customerDetailsId);
//       console.log(customerDetailsId);
//     } else {
//       getCustomerDetails(customerData[0]?.userid);
//     }
//   }, []);

//   const getCustomers = async () => {
//     try {
//       const res = await axios.post(`${Key.domain}/dashboard/getCustomers`, {
//         admin_id: currentUser?.id,
//         session_token: currentUser?.session_token,
//       });
//       if (res.status === 200) {
//         const newData = res.data.data;
//         // console.log('newData', newData);
//         setCustomerData(newData);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const getCustomerDetails = async (id) => {
//     try {
//       const response = await axios.post(`${Key.domain}/customer/get_customerdetails`, {
//         customer_id: id,
//       });
//       if (response.status === 200) {
//         setCustomerDetailsData(response.data.data);
//         console.log(response.data.data);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const detailsHandler = (data, index) => {
//     getCustomerDetails(data?.userid);
//   }

//   const buttonStyles = (buttonName) => ({
//     borderRadius: '0px',
//     p: '4px 15px',
//     color: activeButton === buttonName ? palette.primary.main : palette.grey[600],
//     backgroundColor: activeButton === buttonName ? palette.primary.lighter : 'transparent',
//     borderColor: palette.grey[400],
//     '&:hover': {
//       backgroundColor: activeButton === buttonName ? palette.primary.light : palette.primary.lighter,
//     //   borderColor: activeButton === buttonName ? 'primary.dark' : 'primary.main',
//     },
//     fontSize: styles.fontSize12
//   });

//   return (
//     <Grid container spacing={0}>
//         <Grid item xs={12}>
//         <ButtonGroup variant="outlined" aria-label="Basic button group" size="small">
//       <Button sx={buttonStyles('All')} onClick={() => handleButtonClick('All')}>All</Button>
//       <Button sx={buttonStyles('Monthly')} onClick={() => handleButtonClick('Monthly')}>Monthly</Button>
//       <Button sx={buttonStyles('Yearly')} onClick={() => handleButtonClick('Yearly')}>Yearly</Button>
//       <Button sx={buttonStyles('Custom')} onClick={() => handleButtonClick('Custom')}>Custom</Button>
//     </ButtonGroup>
//         </Grid>
//       <Grid item xs={4}>
//         {/* <Divider /> */}
//         <Box>
//           <List>
//             {customerData.map((data, index) => (
//               <ListItemButton
//               onClick={() => detailsHandler(data, index)}
//                sx={{
//                 borderBottom: '1px solid #ddd'
//               }}>
//                 <Box sx={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
//                   <Box sx={{ display: 'flex', gap: '6px' }}>
//                     <Avatar />
//                     <Box>
//                       <Typography paragraph sx={{ m: 0, fontWeight: 800, fontSize: styles.fontSize16, color: palette.grey[700] }}>
//                         {data?.user_name}
//                       </Typography>
//                       <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize12 }}>
//                         {data?.company_name}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Box sx={{display:'flex', gap:'10px'}}>
//                     <Box>
//                       <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
//                         Enrolled Date
//                       </Typography>
//                       <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
//                         May 24, 2024
//                       </Typography>
//                     </Box>
//                     <Box sx={{ border:'1px solid #ddd'}} />
//                     <Box>
//                       <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
//                         Billing Date
//                       </Typography>
//                       <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
//                         Aprill 24, 2024
//                       </Typography>
//                     </Box>
//                     <Box sx={{ border:'1px solid #ddd'}} />
//                     <Box>
//                       <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
//                         Subscription Daays
//                       </Typography>
//                       <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
//                         70 days
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               </ListItemButton>
//             ))}
//           </List>
//         </Box>
//       </Grid>
//       <Grid item xs={8}>
//         <Box>Details</Box>
//       </Grid>
//     </Grid>
//   );
// };

// export default DetailsView;
